// extracted by mini-css-extract-plugin
export default {"servicesNmcpLogo":"style_servicesNmcpLogo__TxZYd","container":"style_container__kWycb","headerTextContainer":"style_headerTextContainer__9S5Ic"};